export type Alignment = 'left' | 'center' | 'right';
export type VerticalAlignment = 'top' | 'middle' | 'bottom';

export const alignmentToFlexAlignValue = (alignment: Alignment | VerticalAlignment) => {
  switch (alignment) {
    case 'left':
    case 'top':
      return 'flex-start';
    case 'center':
    case 'middle':
      return 'center';
    case 'right':
    case 'bottom':
      return 'flex-end';
    default:
      return undefined;
  }
};
